import TalentDetail from '../../views/talent/Detail.vue';
import PlusItemList from '../../views/talent/PlusItemList.vue';
import SwiperPlusItems from '../../components/swiper/plus-items.vue';
import NewsSwiper from '../../views/home/NewsSwiper.vue';
import RecommendTalents from '../../views/talent/RecommendTalents.vue';
import AttributeSampleImages from '../../views/talent/AttributeSampleImages.vue';
import SampleImageModal from '../../components/SampleImageModal.vue';

// モデル詳細
window.Vue.component('talent-detail', TalentDetail);
window.Vue.component('plus-item-list', PlusItemList);
window.Vue.component('swiper-plus-items', SwiperPlusItems);
window.Vue.component('news-swiper', NewsSwiper);
window.Vue.component('recommend-talents', RecommendTalents);
window.Vue.component('talent-attribute-sample-images', AttributeSampleImages);
window.Vue.component('sample-image-modal', SampleImageModal);
